import { useState } from "react";
import { Link } from "react-router-dom";

function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src="img/logo.png" alt="" />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setOpen(!open)}
        >
          <i className="fas fa-bars"></i>
        </button>

        <div className={`collapse navbar-collapse ${open ? "show" : ""}`} dir="rtl">
          <div className="navbar-nav">
            <Link className="nav-link" to="/" onClick={() => setOpen(false)}>
              الرئيسية
            </Link>
            <Link className="nav-link" to="/about" onClick={() => setOpen(false)}>
              من نحن
            </Link>
            <Link className="nav-link" to="/contact" onClick={() => setOpen(false)}>
              تواصل معنا
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
